import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'instructions_uploads_two',
  templateUrl: './instructions_uploads_two.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryInstructionsUploadsTwoComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  mainTitle;
  subscription = new Subscription();
  instructions = [
    {
      title: 'Snap a photo of each item',
      imageNumber: '10',
      instructionLists: ['Use your device to <span class="font-bold"> capture an image </span> of each item you selected.'],
    },
    {
      title: 'Access the Kinnect mobile delivery portal',
      imageNumber: '11',
      instructionLists: ['Using the same device,<span class="font-bold"> log into the Kinnect mobile delivery portal.</span>'],
    },
    {
      title: 'Upload photos from your mobile device',
      imageNumber: '12',
      instructionLists: ['<span class="font-bold"> Select the photos </span> you want to upload into Kinnect.'],
    },
    {
      title: 'Log out on mobile & delete sensitive photos',
      imageNumber: '13',
      instructionLists: [
        'Make sure you <span class="font-bold"> log out </span> of Kinnect on your mobile device.',
        '<span class="font-bold"> Delete sensitive photos </span> from your device after uploading them into Kinnect.',
      ],
    },
  ];

  constructor(private store: Store) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.mainTitle = `Let’s start <span class="font-bold text-[#25508E]"> uploading selected items </span> from your mobile device`;
      })
    );
  }

  ngOnInit(): void {}

  instructionBackOrForwardEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
